import React from 'react'
// components
import StrategyActions from 'components/PageComponents/Home/components/DashboardWidgets/components/StrategyActions/components/Content'
import StrategyActionsBL from 'containers/StrategyActions/layers/BL'
import StrategyActionsAPI from 'containers/StrategyActions/layers/API'

const StrategyActionsContainer: React.FC = () => {
  return (
    <StrategyActionsAPI>
      <StrategyActionsBL>
        <StrategyActions />
      </StrategyActionsBL>
    </StrategyActionsAPI>
  )
}

export default StrategyActionsContainer
